var LocationData = React.createContext({});
export var LocationDataProvider = LocationData.Provider;
export var LocationDataConsumer = LocationData.Consumer;
export default LocationData;